import { Component, AfterViewInit, ElementRef, Input, ViewChild, OnInit } from '@angular/core';

@Component({
    selector: 'sgt-collapse-group',
    templateUrl: './collapse-group.component.html',
    styleUrls: ['./collapse-group.component.less']
})
export class CollapseGroupComponent implements OnInit, AfterViewInit {
    @Input() title: string;
    @Input() titleTooltip: string;
    @Input() isCollapsedInDefault = true;
    isCollapsedIn: boolean;

    @Input() containerCollpaseMarginBottom = '10px';
    @Input() collpaseTitleMarginTop = '0px';
    @Input() collpaseTitleMarginLeft = '0px';
    @Input() collpaseTitleMarginRight = '0px';
    @Input() collpaseTitleMarginBottom = '10px';

    @ViewChild('collapseContent') collapseContent: ElementRef;

    ngOnInit() {
        this.isCollapsedIn = this.isCollapsedInDefault;
    }

    ngAfterViewInit() {
        if (!this.isCollapsedInDefault) {
            jQuery(this.collapseContent.nativeElement).css('display', 'none');
        }
    }


    /** Abre/Fecha o collapse */
    toggleCollapse(): Promise<void> {
        return new Promise<void>((resolve) => {
            this.isCollapsedIn = !this.isCollapsedIn;
            if (this.isCollapsedIn) {
                this.open()
                    .then(() =>  resolve())
                    .catch(() =>  resolve())
            } else {
                this.close()
                    .then(() =>  resolve())
                    .catch(() =>  resolve())
            }
        });
    }

    /** Abre o collapse */
    open(): Promise<void> {
        return new Promise<void>((resolve) => {
            this.isCollapsedIn = true;
            // jQuery(this.collapseContent.nativeElement).removeClass('animate__animated').removeClass('animate__fadeOut');
            // jQuery(this.collapseContent.nativeElement).addClass('animate__animated').addClass('animate__fadeIn');
            jQuery(this.collapseContent.nativeElement).slideDown(400, () => resolve());
        });
    }

    /** Fecha o collapse */
    close(): Promise<void> {
        return new Promise<void>((resolve) => {
            this.isCollapsedIn = false;
            // jQuery(this.collapseContent.nativeElement).removeClass('animate__animated').removeClass('animate__fadeIn');
            // jQuery(this.collapseContent.nativeElement).addClass('animate__animated').addClass('animate__fadeOut');
            jQuery(this.collapseContent.nativeElement).slideUp(400, () => resolve());
        });
    }
}
